import SynapseStatusPage from "./SynapseStatusPage";
import { REP_ASSIST_HELP_EMAIL } from "../utils/constantFiles/constant";

function SessionExpiredPage() {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <SynapseStatusPage
      variant="error"
      heading="Your session has expired"
      linkHref={`mailto:${REP_ASSIST_HELP_EMAIL}`}
      linkText={REP_ASSIST_HELP_EMAIL}
      linkSuffix="if signing in again does not help."
      showRetryButton
      onRetry={handleRetry}
    />
  );
}

export default SessionExpiredPage;
